module.exports = __webpack_public_path__ + "img/arrow.c322ea58.svg";